import { render, staticRenderFns } from "./newPassword.vue?vue&type=template&id=73f3a3cb&scoped=true&"
import script from "./newPassword.vue?vue&type=script&lang=js&"
export * from "./newPassword.vue?vue&type=script&lang=js&"
import style0 from "./newPassword.vue?vue&type=style&index=0&id=73f3a3cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f3a3cb",
  null
  
)

export default component.exports